import React from "react";
import { Parcours } from "../../../modules/academy/parcours/models/Parcours";
import { ParcoursStep } from "../../../modules/academy/parcours/models/ParcoursStep";
import { ParcoursStepCard } from "./ParcoursStepCard";

interface ParcoursStepListProps {
  parcours: Parcours;
  completedSteps: string[];
  currentStepId?: string;
  isGuest: boolean;
  onOpenStep: (step: ParcoursStep) => void;
  onMarkDone: (step: ParcoursStep) => void;
}

export function ParcoursStepList({
  parcours,
  completedSteps,
  currentStepId,
  isGuest,
  onOpenStep,
  onMarkDone,
}: ParcoursStepListProps) {
  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold">Etapes du parcours</h2>
      <div className="space-y-3">
        {parcours.steps.map((step, idx) => {
          const isCompleted = completedSteps.includes(step.id);
          const isCurrent = currentStepId ? currentStepId === step.id : !isCompleted;
          return (
            <ParcoursStepCard
              key={step.id}
              step={step}
              index={idx}
              isCompleted={isCompleted}
              isCurrent={isCurrent}
              isGuest={isGuest}
              onOpenStep={() => onOpenStep(step)}
              onMarkDone={() => onMarkDone(step)}
            />
          );
        })}
      </div>
    </section>
  );
}
